import React, { useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
// import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import * as Yup from 'yup';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
// import { adminMainUrl } from '../../../../Config';
const EditMaster = ({ show, handleClose, onSuccess }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const closeButtonRef = useRef(null);
    const validationSchema = Yup.object({
        name: Yup.string().required('Dimension Name is required'),

        // name: Yup.string().required('Code is required'),
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            name: '', // Initial value for the RequiredService type

        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            handleClose()
            formik.resetForm();
            setIsSubmitting(true);
            // try {
            //     const response = await fetch(`${adminMainUrl}/api/department/create`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
            //         },
            //         body: JSON.stringify(values),
            //     });

            //     const data = await response.json();

            //     if (response.ok) {
            //         // closeButtonRef.current.click();
            //         if (onSuccess) onSuccess();
            //         toast.success(data?.msg);
            //         handleClose()
            //         formik.resetForm();
            //     } else {
            //         toast.error(data?.msg);
            //         // Handle errors from the server
            //         console.error('Error creating RequiredService Type:', data.message);
            //     }
            // } catch (error) {
            //     console.error('Network error:', error);
            // }
            // finally {
            //     setIsSubmitting(false); // Stop the spinner
            // }
        },
    });
    const ApplicableOption = []
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Edit Dimension</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-12">

                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Dimension Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="name"
                                    name="name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                />
                                {formik.touched.name && formik.errors.name ? (
                                    <div className="error">{formik.errors.name}</div>
                                ) : null}
                            </div>
                        </div>

                    </div>
                    <div className="d-flex justify-content-end">
                        {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
                        <button className="btn btn-primary text-xs" type="submit" >
                            Submit
                        </button>
                    </div>

                </form>
            </Modal.Body>
        </Modal>
    )
}

export default EditMaster